var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "aria-label": "Pagination" } }, [
    _c(
      "ul",
      { staticClass: "pagination" },
      [
        _c(
          "li",
          {
            staticClass: "page-item",
            class: { disabled: _vm.currentPage === 0 },
            on: { click: _vm.showPrev }
          },
          [_vm._m(0)]
        ),
        _vm._v(" "),
        _vm._l(_vm.pages, function(pageNo) {
          return _c(
            "li",
            {
              key: pageNo,
              staticClass: "page-item",
              class: { active: _vm.currentPage === pageNo },
              on: {
                click: function($event) {
                  return _vm.showPage(pageNo)
                }
              }
            },
            [
              _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                _vm._v("\n        " + _vm._s(pageNo + 1) + "\n      ")
              ])
            ]
          )
        }),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "page-item",
            class: { disabled: _vm.currentPage + 1 >= _vm.totalPages },
            on: { click: _vm.showNext }
          },
          [_vm._m(1)]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
      _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("«")]),
      _vm._v(" "),
      _c("span", { staticClass: "sr-only" }, [_vm._v("Previous")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
      _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("»")]),
      _vm._v(" "),
      _c("span", { staticClass: "sr-only" }, [_vm._v("Next")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-171493d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-171493d0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/Pagination.vue
// module id = 426
// module chunks = 0